import { Link } from 'react-router'
import { Icon } from '#app/components/ui/icon.tsx'

interface BreadcrumbPage {
	name: string
	href: string
	current?: boolean
	ellipsis?: boolean
}

interface BreadcrumbProps {
	pages: BreadcrumbPage[]
}

export function Breadcrumb({ pages }: BreadcrumbProps) {
	return (
		<nav className="flex" aria-label="Breadcrumb">
			<ol className="flex items-center space-x-2">
				{pages.map((page, index) => (
					<li key={page.name}>
						<div className="flex items-center whitespace-nowrap">
							{index !== 0 && (
								<Icon
									name="chevron-right"
									size="sm"
									className="mr-1 h-4 w-4 text-gray-400"
								/>
							)}

							{page.ellipsis ? (
								<span className="mx-1 text-sm text-gray-500">...</span>
							) : page.current ? (
								<span
									className="line-clamp-1 bg-amber-100 px-2 text-sm font-medium text-amber-700"
									aria-current="page"
								>
									{page.name.slice(0, 40) +
										(page.name.length > 40 ? '...' : '')}
								</span>
							) : (
								<Link
									to={page.href}
									className="line-clamp-1 text-sm font-medium text-gray-500 hover:font-bold hover:text-amber-700"
								>
									{page.name.slice(0, 40) +
										(page.name.length > 40 ? '...' : '')}
								</Link>
							)}
						</div>
					</li>
				))}
			</ol>
		</nav>
	)
}
